export enum SsoTestIds {
  REAUTH_MODAL = 'sso-reauth-modal',
  REAUTH_MODAL_ACTION = 'sso-reauth-modal-action',
}
